var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { staticClass: "login-form" },
    [
      _c(
        "el-form-item",
        [
          _c(
            "sw-input",
            {
              attrs: {
                size: "defualt",
                placeholder:
                  _vm.i18n["screen.welcome.label.mobile.placeholder"] ||
                  "请输入绑定的手机号",
                circular: ""
              },
              model: {
                value: _vm.mobile,
                callback: function($$v) {
                  _vm.mobile = $$v
                },
                expression: "mobile"
              }
            },
            [
              _c("i", {
                staticClass:
                  "su-input-icon black su-input-icon-prefix el-input__icon su-icon-phone",
                attrs: { slot: "prefix" },
                slot: "prefix"
              })
            ]
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "relative" },
        [
          _c(
            "sw-input",
            {
              staticClass: "su-input-text-button code-pwd-style",
              attrs: {
                size: "defualt",
                placeholder:
                  _vm.i18n["screen.welcome.label.dynamiccode.placeholder"] ||
                  "请输入验证码",
                circular: ""
              },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.smsCodeLogin(_vm.mobile, _vm.dynamiccode)
                }
              },
              model: {
                value: _vm.dynamiccode,
                callback: function($$v) {
                  _vm.dynamiccode = $$v
                },
                expression: "dynamiccode"
              }
            },
            [
              _c("i", {
                staticClass:
                  "su-input-icon black su-input-icon-prefix el-input__icon su-icon-dyncode",
                attrs: { slot: "prefix" },
                slot: "prefix"
              }),
              _c(
                "el-button",
                {
                  attrs: { slot: "append" },
                  on: {
                    click: function($event) {
                      return _vm.smsCodeSend(_vm.mobile)
                    }
                  },
                  slot: "append"
                },
                [_vm._v(_vm._s(_vm.sendButtonText))]
              )
            ],
            1
          ),
          !_vm.loginError
            ? _c("div", { staticClass: "login-error" }, [
                _vm._v(" " + _vm._s(_vm.loginError) + " ")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form-item",
        {},
        [
          _c(
            "el-button",
            {
              staticClass: "login-btn",
              staticStyle: { width: "100%" },
              attrs: {
                size: "defualt",
                type: "primary",
                "native-type": "button",
                round: ""
              },
              on: {
                click: function($event) {
                  return _vm.smsCodeLogin(_vm.mobile, _vm.dynamiccode)
                }
              }
            },
            [_vm._v(_vm._s(_vm.i18n["screen.welcome.button.login"] || "登 录"))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }